(() => {
  const initializeFormixxHowItWorksRow = (scope = document) => {
    scope
      .querySelectorAll(
        '[data-formixx-hiw-row]:not([data-hiw-row-initialized])'
      )
      .forEach((section) => {
        section.dataset.hiwRowInitialized = 'true';

        if (!('IntersectionObserver' in window)) {
          section.classList.add('is-visible');
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              section.classList.add('is-visible');
              observer.unobserve(section);
            });
          },
          {
            threshold: 0.16,
            rootMargin: '0px 0px -8% 0px'
          }
        );

        observer.observe(section);
      });
  };

  initializeFormixxHowItWorksRow();

  document.addEventListener('shopify:section:load', (event) => {
    initializeFormixxHowItWorksRow(event.target);
  });
})();
